"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
function conditionFilter(raw) {
    var conditionParam = raw;
    if (!Array.isArray(raw)) {
        conditionParam = [raw];
    }
    var usedConditions = lodash_1.intersection(['used', 'b-stock', 'non-functioning'], conditionParam);
    var newConditions = lodash_1.intersection(['new'], conditionParam);
    if (usedConditions.length && !newConditions.length) {
        return 'used';
    }
    if (newConditions.length && !usedConditions.length) {
        return 'new';
    }
}
exports.conditionFilter = conditionFilter;
//# sourceMappingURL=condition_filter.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/csp/condition_filter.js
// module id = 3FdC
// module chunks = 20 21